export const EDIT_ACCESS_ADMINS = [
    'michelle.agatha@roomtoread.org',
    'gabriel.salazar@roomtoread.org',
    'admin@sample.com',
];

export const SECTION_BANNER_TYPES = {
    intro: 'INTRO',
    signUp: 'SIGNUP',
    affiliation: 'AFFILIATION',
};
